import { render, staticRenderFns } from "./DetailedTicketView.vue?vue&type=template&id=4ad7a89d"
import script from "./DetailedTicketView.vue?vue&type=script&lang=ts"
export * from "./DetailedTicketView.vue?vue&type=script&lang=ts"
import style0 from "./DetailedTicketView.vue?vue&type=style&index=0&id=4ad7a89d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports